import {
  CalculateCartPayload,
  DeliveryType,
  DBProduct,
  ProductDbIdPayload,
} from "@commons-monorepo/index";

export const getDbProductId = (product: ProductDbIdPayload): string => {
  const concatToppings =
    product.variationId ||
    (product?.toppings
      ? product?.toppings
          .map(
            (topping) =>
              `-topping-${topping.parentIndex}_${topping.toppingName}_${topping.value}`,
          )
          .join("-")
      : "");
  return `${product.id}${concatToppings}`;
};

export const mapCalculatorPayload = ({
  products,
  origin_type,
  catalogue_link,
  cart_id,
  locale,
  currency,
  couponCode,
  email,
  chatId
}: {
  products: DBProduct[];
  origin_type: string;
  catalogue_link: string;
  cart_id: string | null;
  locale: string;
  currency: string;
  couponCode?: string;
  email?: string;
  chatId?: string;
}): CalculateCartPayload => {
  const productsCart = products
    .filter((product) => !product.kit)
    .map((product) => {
      return {
        product_id: product.id,
        units: product.quantity,
        variation_id: product.variationId,
        toppings: product.toppings
          ? product.toppings?.map((topping) => {
              return {
                name: topping.toppingName || "",
                values: [{ value: topping.value || "" }],
              };
            })
          : [],
      };
    });

  const kitsCart = products
    .filter((product) => !!product.kit)
    .map((product) => ({
      kitId: product.id,
      products:
        product.kit?.products.map((productKit) => ({
          productId: productKit.productId,
        })) || [],
    }));

  return {
    products: productsCart,
    kits: kitsCart,
    delivery_type: DeliveryType.PickUp,
    origin_type,
    catalogue_link,
    locale,
    currency,
    coupons: couponCode ? [couponCode] : undefined,
    customer_email: email,
    additional_information: {
      cart_id: cart_id || undefined,
      chat_id: chatId || '',
    },
  }
};
